import { render } from "./CustomPhoneInput.vue?vue&type=template&id=674c1271&scoped=true"
import script from "./CustomPhoneInput.vue?vue&type=script&lang=js"
export * from "./CustomPhoneInput.vue?vue&type=script&lang=js"

import "./CustomPhoneInput.vue?vue&type=style&index=0&id=674c1271&lang=scss"
import "./CustomPhoneInput.vue?vue&type=style&index=1&id=674c1271&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674c1271"]])

export default __exports__